import { isCompanyCuit } from "../../utils/utils";

const validate = values => {
	const errors = {}
	if (!values.email) {
		errors.email = 'Este campo es obligatorio'
	}
	if (values.document_number && !/(\d{7}|\d{8})$/.test(values.document_number)) {
		errors.document_number = 'El documento no es válido'
	}
	if (!values.area_code) {
		errors.area_code = 'Este campo es obligatorio'
	}
	if (!values.number) {
		errors.number = 'Este campo es obligatorio'
	}
	if (!values.state_id || values.state_id === 'false') {
		errors.state_id = 'Este campo es obligatorio'
	}
	if (values.cuil && isCompanyCuit(values.cuil) && !values.facto_business_association) {
		errors.facto_business_association = 'Este campo es obligatorio'
	}
	return errors
}

export default validate


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsMainForm.js
 **/